import React, { Component } from 'react';
import './booking.css';
import { render } from 'react-dom';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import { Calendar, ChevronRight, Image, Navigation } from 'react-feather';
import * as L from 'leaflet';

import junc from '../../assets/images/junc.png';
import mk1 from '../../assets/images/mk1.png'; // Hammashoitola Oy
import mk2 from '../../assets/images/mk2.png'; // Espoo Dental Care
import mk3 from '../../assets/images/mk3.png'; // Matti Meikäläainen Tmi
import mk4 from '../../assets/images/mk4.png'; // Joutomiehet
import mk5 from '../../assets/images/mk5.png'; // Espoo Private Dentals
import mk6 from '../../assets/images/mk6.png'; // Otaniemi Dentists Oy
import mk7 from '../../assets/images/mk7.png'; // Dentagon Ltd.
import mk8 from '../../assets/images/mk8.png'; // Finnish Oil Company

const icons = [mk1, mk5, mk4, mk2, mk3, mk8, mk6, mk7];

const deg2rad = deg => {
  return deg * (Math.PI / 180);
};

const shoopDaWoop = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
};

const positions = [
  {
    location: [60.185468, 24.826998],
    name: 'Hammashoitola Oy',
    description: 'The first dentist in Finland.',
    color: '#2981ca',
    dist: Math.round(
      1000 * shoopDaWoop(60.185468, 24.826998, 60.185046, 24.832298)
    ),
  },
  {
    location: [60.181113, 24.827062],
    name: 'Espoo Private Dentals',
    description: 'Cheap dental care in Espoo',
    color: '#058e6c',
    dist: Math.round(
      1000 * shoopDaWoop(60.181113, 24.827062, 60.185046, 24.832298)
    ),
  },
  {
    location: [60.188719, 24.839733],
    name: 'Joutomiehet',
    description: 'Do not go here',
    color: '#bb6216',
    dist: Math.round(
      1000 * shoopDaWoop(60.188719, 24.839733, 60.185046, 24.832298)
    ),
  },
  {
    location: [60.184118, 24.821022],
    name: 'Espoo Dental Care',
    description: 'Public service',
    color: '#8661e4',
    dist: Math.round(
      1000 * shoopDaWoop(60.184118, 24.821022, 60.185046, 24.832298)
    ),
  },
  {
    location: [60.191038, 24.831594],
    name: 'Matti Meikäläinen Tmi',
    description: 'The best money can get!',
    color: '#d6544a',
    dist: Math.round(
      1000 * shoopDaWoop(60.191038, 24.831594, 60.185046, 24.832298)
    ),
  },
  {
    location: [60.179235, 24.836532],
    name: 'Finnish Oil Company',
    description: 'Well it could be a clinic..',
    color: '#ef7f78',
    dist: Math.round(
      1000 * shoopDaWoop(60.179235, 24.836532, 60.185046, 24.832298)
    ),
  },
  {
    location: [60.180638, 24.847071],
    name: 'Otaniemi Dentists Oy',
    description: 'Engineering students gone wild',
    color: '#2f931f',
    dist: Math.round(
      1000 * shoopDaWoop(60.180638, 24.847071, 60.185046, 24.832298)
    ),
  },
  {
    location: [60.183576, 24.80946],
    name: 'Dentagon Ltd.',
    description: 'B2B Only',
    color: '#bdb301',
    dist: Math.round(
      1000 * shoopDaWoop(60.183576, 24.80946, 60.185046, 24.832298)
    ),
  },
];

const location = [60.185046, 24.832298];

const junctionIcon = L.icon({
  iconUrl: junc,
  iconSize: [36, 36],
  iconAnchor: [18, 18],
});

const map = (
  <Map center={positions[0].location} zoom={15}>
    <TileLayer url="https://{s}.tiles.mapbox.com/v4/mapbox.pencil/{z}/{x}/{y}.png?access_token=pk.eyJ1Ijoiam9vam9vODg5ODkiLCJhIjoiY2phZnczdDRpMjFwazJ5bnU5ZG01c3o2eiJ9.n6sY8fIf-iCrJrhaveTMEg" />
    <Marker icon={junctionIcon} position={location}>
      <Popup>
        <span>
          Your location:<br />Junction 2017
        </span>
      </Popup>
    </Marker>
    {positions.map((pos, i) => {
      const currentIcon = L.icon({
        iconUrl: icons[i],
        iconSize: [25, 41],
        iconAnchor: [12.5, 41],
        popupAnchor: [1, -20],
      });
      return (
        <Marker
          key={pos.location[0]}
          icon={currentIcon}
          position={pos.location}
        >
          <Popup>
            <span>
              <strong>{pos.name}</strong>
              <br />
              {pos.description} <br /> Distance: <strong>{pos.dist}</strong> m
            </span>
          </Popup>
        </Marker>
      );
    })}
  </Map>
);

class Booking extends Component {
  state = {
    positions: [
      {
        location: [60.185468, 24.826998],
        name: 'Hammashoitola Oy',
        description: 'The first dentist in Finland.',
        color: '#2981ca',
        dist: Math.round(
          1000 * shoopDaWoop(60.185468, 24.826998, 60.185046, 24.832298)
        ),
      },
      {
        location: [60.181113, 24.827062],
        name: 'Espoo Private Dentals',
        description: 'Cheap dental care in Espoo',
        color: '#058e6c',
        dist: Math.round(
          1000 * shoopDaWoop(60.181113, 24.827062, 60.185046, 24.832298)
        ),
      },
      {
        location: [60.188719, 24.839733],
        name: 'Joutomiehet',
        description: 'Do not go here',
        color: '#bb6216',
        dist: Math.round(
          1000 * shoopDaWoop(60.188719, 24.839733, 60.185046, 24.832298)
        ),
      },
      {
        location: [60.184118, 24.821022],
        name: 'Espoo Dental Care',
        description: 'Public service',
        color: '#8661e4',
        dist: Math.round(
          1000 * shoopDaWoop(60.184118, 24.821022, 60.185046, 24.832298)
        ),
      },
      {
        location: [60.191038, 24.831594],
        name: 'Matti Meikäläinen Tmi',
        description: 'The best money can get!',
        color: '#d6544a',
        dist: Math.round(
          1000 * shoopDaWoop(60.191038, 24.831594, 60.185046, 24.832298)
        ),
      },
      {
        location: [60.179235, 24.836532],
        name: 'Finnish Oil Company',
        description: 'Well it could be a clinic..',
        color: '#ef7f78',
        dist: Math.round(
          1000 * shoopDaWoop(60.179235, 24.836532, 60.185046, 24.832298)
        ),
      },
      {
        location: [60.180638, 24.847071],
        name: 'Otaniemi Dentists Oy',
        description: 'Engineering students gone wild',
        color: '#2f931f',
        dist: Math.round(
          1000 * shoopDaWoop(60.180638, 24.847071, 60.185046, 24.832298)
        ),
      },
      {
        location: [60.183576, 24.80946],
        name: 'Dentagon Ltd.',
        description: 'B2B Only',
        color: '#bdb301',
        dist: Math.round(
          1000 * shoopDaWoop(60.183576, 24.80946, 60.185046, 24.832298)
        ),
      },
    ],
    upcoming: [
      {
        title: 'Up title 1',
        date: '02.12.2017',
        location: 'Otaniemi',
        short: 'Short description',
        description:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ' +
          "has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley " +
          'of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also ' +
          'the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with ' +
          'the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing ' +
          'software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
      {
        title: 'Up title 2',
        date: '16.03.2018',
        location: 'Otaniemi',
        short: 'Short description',
        description:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ' +
          "has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley " +
          'of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also ' +
          'the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with ' +
          'the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing ' +
          'software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
      {
        title: 'Up title 2',
        date: '16.03.2018',
        location: 'Otaniemi',
        short: 'Short description',
        description:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ' +
          "has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley " +
          'of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also ' +
          'the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with ' +
          'the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing ' +
          'software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
      {
        title: 'Up title 2',
        date: '16.03.2018',
        location: 'Otaniemi',
        short: 'Short description',
        description:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ' +
          "has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley " +
          'of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also ' +
          'the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with ' +
          'the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing ' +
          'software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
      {
        title: 'Up title 2',
        date: '16.03.2018',
        location: 'Otaniemi',
        short: 'Short description',
        description:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ' +
          "has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley " +
          'of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also ' +
          'the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with ' +
          'the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing ' +
          'software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
      {
        title: 'Up title 2',
        date: '16.03.2018',
        location: 'Otaniemi',
        short: 'Short description',
        description:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ' +
          "has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley " +
          'of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also ' +
          'the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with ' +
          'the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing ' +
          'software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
      {
        title: 'Up title 2',
        date: '16.03.2018',
        location: 'Otaniemi',
        short: 'Short description',
        description:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ' +
          "has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley " +
          'of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also ' +
          'the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with ' +
          'the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing ' +
          'software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
      {
        title: 'Up title 2',
        date: '16.03.2018',
        location: 'Otaniemi',
        short: 'Short description',
        description:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ' +
          "has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley " +
          'of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also ' +
          'the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with ' +
          'the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing ' +
          'software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
    ],
  };

  componentDidMount() {
    render(map, document.getElementsByClassName('map-container')[0]);
  }

  toggle = e => {
    const content = e.target.previousSibling.lastChild;
    console.log(content);
    if (content && content.classList) {
      if (content.classList.contains('expanded')) {
        content.classList.remove('expanded');
      } else {
        const prevExpanded = document.getElementsByClassName(
          'event-content expanded'
        );
        if (prevExpanded.length > 0) {
          prevExpanded[0].classList.remove('expanded');
        }
        content.classList.add('expanded');
      }
    }
  };

  render() {
    return (
      <div className="booking">
        <div className="container">
          <div className="map-container" />
          <div className="list">
            <div className="events-column">
              <h3>Dental clinics near you</h3>
              <ul className="events-upcoming bookingsList">
                {this.state.upcoming.map((e, i) => {
                  return (
                    <li
                      className="upcoming-event event"
                      style={{ background: this.state.positions[i].color }}
                      key={i}
                    >
                      <div className="left">
                        <Image size={70} />
                      </div>
                      <div className="right">
                        <h4 className="title">
                          {this.state.positions[i].name}
                        </h4>
                        <p>{this.state.positions[i].description}</p>
                        <p>
                          <Navigation size={20} />
                          <span>
                            {this.state.positions[i].dist} metres away
                          </span>
                        </p>
                        <p>
                          <Calendar size={20} />
                          <span>{e.date}</span>
                        </p>
                        <div className="event-content">
                          <p>{e.description}</p>
                        </div>
                      </div>
                      <div
                        className="clickable"
                        onClick={e => this.toggle(e)}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Booking;



// WEBPACK FOOTER //
// ./src/components/Booking/index.js